/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1IndividualpaymentParcelsParcelidCancelInvoice200,
  PostApiV1IndividualpaymentParcelsParcelidCancelInvoice400,
  PostApiV1IndividualpaymentParcelsParcelidCancelInvoice401,
  PostApiV1IndividualpaymentParcelsParcelidCancelInvoice500,
  PostApiV1IndividualpaymentParcelsParcelidCancelInvoiceMutationResponse,
  PostApiV1IndividualpaymentParcelsParcelidCancelInvoicePathParams,
  PostApiV1IndividualpaymentParcelsParcelidCancelInvoiceQueryParams,
} from "../../types/individualPaymentInvoicesController/PostApiV1IndividualpaymentParcelsParcelidCancelInvoice.ts";

export const postApiV1IndividualpaymentParcelsParcelidCancelInvoicePathParamsSchema =
  z.object({
    parcelId: z.coerce.number().int(),
  }) as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidCancelInvoicePathParams>;

export const postApiV1IndividualpaymentParcelsParcelidCancelInvoiceQueryParamsSchema =
  z.object({
    reversePayment: z.boolean().default(false),
  }) as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidCancelInvoiceQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1IndividualpaymentParcelsParcelidCancelInvoice200Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidCancelInvoice200>;

/**
 * @description Regra de negócio violada
 */
export const postApiV1IndividualpaymentParcelsParcelidCancelInvoice400Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidCancelInvoice400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1IndividualpaymentParcelsParcelidCancelInvoice401Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidCancelInvoice401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1IndividualpaymentParcelsParcelidCancelInvoice500Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidCancelInvoice500>;

export const postApiV1IndividualpaymentParcelsParcelidCancelInvoiceMutationResponseSchema =
  z.lazy(
    () => postApiV1IndividualpaymentParcelsParcelidCancelInvoice200Schema,
  ) as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidCancelInvoiceMutationResponse>;
